import React from 'react';
import { Box, Select, MenuItem, SelectChangeEvent, FormControl } from '@mui/material';
import { translate as t } from 'hooks/useTranslations';
import ActionMenu from 'components/_atoms/ActionMenu';
import { neutral } from '_lex/_foundations/phxColors';
import { TimeRangeFilter } from '../_types';
import { MOCK_MANUALS, TIME_RANGE_OPTIONS } from '../_constants';
import { useRiskPoolOrgContext } from '../../RiskPoolOrgContext';

interface OrganizationalTrendsFiltersProps {
  selectedManual: string;
  onManualChange: (event: SelectChangeEvent<string>) => void;
  onReportSelect: (reportType: string) => void;
}

export default function OrganizationalTrendsFilters({
  selectedManual,
  onManualChange,
  onReportSelect,
}: OrganizationalTrendsFiltersProps) {
  const { timeRangeFilter, setTimeRangeFilter } = useRiskPoolOrgContext();

  const handleTimeRangeChange = (event: SelectChangeEvent<string>) => {
    setTimeRangeFilter(event.target.value as TimeRangeFilter);
  };

  const reportMenuItems = [
    {
      key: 'memberPerformance',
      label: t('dashboard.riskPool.riskPoolOrg.reports.memberPerformance'),
      onClick: () => onReportSelect('memberPerformance'),
    },
    {
      key: 'memberPolicyAudit',
      label: t('dashboard.riskPool.riskPoolOrg.reports.memberPolicyAudit'),
      onClick: () => onReportSelect('memberPolicyAudit'),
    },
    {
      key: 'agencyPolicyMetrics',
      label: t('dashboard.riskPool.riskPoolOrg.reports.agencyPolicyMetrics'),
      onClick: () => onReportSelect('agencyPolicyMetrics'),
    },
  ];

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
      {/* Time Range Dropdown */}
      <FormControl sx={{ p: 0 }}>
        <Select
          value={timeRangeFilter}
          onChange={handleTimeRangeChange}
          displayEmpty
          renderValue={(value) => {
            const option = TIME_RANGE_OPTIONS.find((o) => o.value === value);
            return (
              <Box component='span'>
                <Box component='span' sx={{ fontWeight: 500, color: neutral[900] }}>
                  Time range:{' '}
                </Box>
                {option?.label ?? value}
              </Box>
            );
          }}
          sx={{
            minWidth: 210,
            backgroundColor: 'white',
            height: 36.5,
            '& .MuiSelect-select': { py: 0.75 },
          }}
        >
          {TIME_RANGE_OPTIONS.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {/* Manual Dropdown — hidden until manual filtering is ready */}

      {/* Reports Button
      <ActionMenu
        id='reports-menu'
        btnText={t('dashboard.riskPool.riskPoolOrg.filters.reports')}
        items={reportMenuItems}
        btnProps={{
          size: 'small',
        }}
        anchorOrigin='left'
      /> */}
    </Box>
  );
}
